import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { SiteContentProvider } from "@/contexts/SiteContentContext";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import ShuttleRequestPage from "@/pages/ShuttleRequestPage";
import BookingResumePage from "@/pages/BookingResumePage";
import CheckinCompletePage from "@/pages/CheckinCompletePage";
import GiftTicketPage from "@/pages/GiftTicketPage";
import PublicCleaningPlanPage from "@/pages/PublicCleaningPlanPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminCalendarPage from "@/pages/AdminCalendarPage";
import AdminChannelManagerPage from "@/pages/AdminChannelManagerPage";
import AdminWidgetPage from "@/pages/AdminWidgetPage";
import WhatsAppFab from "@/components/WhatsAppFab";
import TawkChatButton from "@/components/TawkChatButton";
import ErrorBoundary from "@/components/ErrorBoundary";

// (Despite filename, now renders a phone-call FAB — landline +39 0965 181 7260)

// Renders public-only floating action buttons (chat + phone). Hidden on /admin/* routes.
const PublicFabs = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <>
      <WhatsAppFab />
      <TawkChatButton />
    </>
  );
};

function App() {
  return (
    <ErrorBoundary>
    <LanguageProvider>
      <SiteContentProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/booking" element={<BookingPage />} />
              <Route path="/shuttle-request" element={<ShuttleRequestPage />} />
              <Route path="/booking/resume/:code" element={<BookingResumePage />} />
              <Route path="/checkin/complete" element={<CheckinCompletePage />} />
              <Route path="/gift/:token" element={<GiftTicketPage />} />
              <Route path="/pulizie/:token" element={<PublicCleaningPlanPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
              <Route path="/admin/calendar" element={<AdminCalendarPage />} />
              <Route path="/admin/channel-manager" element={<AdminChannelManagerPage />} />
              <Route path="/admin/widget" element={<AdminWidgetPage />} />
            </Routes>
            <PublicFabs />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </SiteContentProvider>
    </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
